import { TableRow, TableCell, Typography, Button, Tooltip } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { MyAvatar } from 'src/components/common';

// ----------------------------------------------------------------------

export default function MediaPlaylistTableRow({ row, rowNumber, selectContentHandler, index, items }) {
  const { MediaGroupID, MediaGroupTitle, MediaGroupImage, MediaGroupTypeLable } = row;

  const textRefs = useRef([]);
  const [tooltipVisibility, setTooltipVisibility] = useState([]);

  useEffect(() => {
    const visibility = items?.map((_, index) => {
      const el = textRefs.current[index];
      return el && el.scrollWidth > el.clientWidth;
    });
    setTooltipVisibility(visibility);
  }, [items]);

  return (
    <TableRow hover>
      <TableCell align="center">
        <Typography variant="body1">{rowNumber}</Typography>
      </TableCell>

      <TableCell align="center" sx={{ display: 'flex', alignItems: 'center' }}>
        <MyAvatar alt={MediaGroupTitle} sx={{ mr: 2 }} src={MediaGroupImage || '-'} />

        <Tooltip
          title={
            tooltipVisibility[index] ? <Typography sx={{ fontSize: '0.9rem', padding: '0.6rem 0' }}>{MediaGroupTitle}</Typography> : ''
          }
          disableHoverListener={!tooltipVisibility[index]}
        >
          <Typography
            ref={(el) => (textRefs.current[index] = el)}
            variant="body1"
            sx={{
              maxWidth: { xs: '300px', xl: '400px', xxl: '700px' },
              width: 'auto',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {MediaGroupTitle || '-'}
          </Typography>
        </Tooltip>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{MediaGroupTypeLable}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{MediaGroupID}</Typography>
      </TableCell>

      <TableCell align="right">
        <Button color="warning" variant="contained" onClick={() => selectContentHandler(row)}>
          انتخاب
        </Button>
      </TableCell>
    </TableRow>
  );
}
